export const messages = {
  de: {
    message: {
      central: "Zeit-/ Zentralsteuerung",
      windows: "Fenster",
      others: "Andere",
      security: "Zugang/ Sicherheit",
      other: "Andere",
      deactivate: "Deaktivieren",
      activate: "Aktivieren",
      content: "Inhalt",
      inlays: "Projektinlays für: ",
      selectGTs: "GTs auswählen",
      barGrLEDs: "Bargraph-LEDs",
      noSelection: "Keine Auswahl vorhanden",
      icons: "Icons",
      access: "Zugang/ Sicherheit",
      add: "Hinzufügen",
      chooseProjectName: "Bitte Projektnamen eingeben:",
      projectname: "Projektname",
      next: "Weiter",
      oldModels: "GT Modelle der 2009er Serie anzeigen",
      newModels: "GT Modelle der 2013er Serie anzeigen",
      oldGTD:
        'Dies ist der neue GT-Designer! <br> Projekte des alten GT-Designers können Sie leider nicht im neuen GT-Designer importieren. Falls Sie auf den alten GT-Designer zugreifen möchten, können Sie dies <a href="https://lcn.eu/gtdesignerlegacy">hier</a> tun.</small>',
      serviceBeschriftung:
        '<span class="h5"><strong>Neu!</strong></span> Unser <strong>Beschriftungsservice</strong> für ihre GT-Serie! Details und Informationen dazu finden Sie <a href="https://www.lcn.eu/service/beschriftungsservice/">hier</a>.',

      saveSelected: "Auswahl speichern",
      deleteSelected: "Auswahl löschen",
      buttonSelection: "Tastenauswahl",
      changeOrientationVertical: "Vertikale Ausrichtung",
      changeOrientationHorizontal: "Horizontale Ausrichtung",
      changeOrientation: "Ausrichtung drehen",
      hideSelectedLEDs: "Auswahl ausblenden",
      additionalText: "Zusätzliche Beschriftung",
      move: "verschieben",
      hotel: "Hotel",
      clickGT: "Bitte auf ein GT-Modell klicken.",
      deselectAll: "Auswahl aufheben",
      revertKeys: "Möchten Sie das ursprüngliche Tastenlayout zurück?",
      importOverview: "Import-Übersicht",
      modelProject: "Projektvorlage",
      templateTitle: "Vorlagen zum Download",
      modelProjectGreen: "Projektvorlage Grün",
      modelProjectBlue: "Projektvorlage Blau",
      modelProjectYellow: "Projektvorlage Gelb",
      modelProjectWhite: "Projektvorlage Weiss",
      templates: "Vorlagen",
      view: "ansehen",
      copy: "kopieren",
      delete: "löschen",
      showOverview: "Übersicht anzeigen",
      importDownload:
        "Über 'Projekt importieren' können Sie die Vorlagen im Designer bearbeiten.",
      printBorder:
        "In Ihrem Druck-Fenster in den erweiterten Einstellungen die Ränder auf 'Minimal' ändern um das beste Druckergebnis zu erhalten",
      bargraphCAlternating: "Alternierend",
      bargraphCRight: "Rechts",
      bargraphCLeft: "Links",
      bargraphCUp: "Oben",
      bargraphCDown: "Unten",
      // addAndEdit: "hinzufügen und bearbeiten",
      // addInlay: "Inlay hinzufügen",
      // addText: "Text hinzufügen",
      // aidinglines: "Hilfslinien",
      // alphaHint: "Transparenz der gewählten Farbe über Skala wählbar",
      // alphaMode: "Transparenzmodus",
      alignment: "Ausrichtung",
      // alignmentInfo:
      //   "Taste durch Klick markieren und entsprechendes Icon für Text-Ausrichtung klicken",
      // alignCenter: "mittig ausrichten(horizontal)",
      // alignLeft: "links ausrichten",
      // alignRight: "rechts ausrichten",
      angle: "Winkel",
      angled: "eckig",
      // apply: "anwenden",
      // back: "Zurück",
      background: "Hintergrund",
      // backgroundImgs: "Hintergrundbilder",
      backToProjOverview: "Zur Projektübersicht",
      // bargrCaption: "Bargraph- beschriftung",
      // "Black-and-white-icons": "Schwarz-weiß-Icons",
      // bold: "fett",
      border: "Rahmen",
      // brightnessHint: "Helligkeit der gewählten Farbe über Skala wählbar",
      // brightnessMode: "Helligkeitsmodus",
      caption: "Beschriftung",
      // captionHint1:
      //   "Mit Mauszeiger in Text klicken und einfach über Tastatur bearbeiten ",
      // captionHint2: "Löschen über Backspace ← oder Entfernen-Taste",
      changeMode: "Wechselmodus",
      // changeModeInfo:
      //   'Im Wechselmodus können Sie <b>Tasten gegeneinander austauschen</b>.<br> Taste mit der Maus auf gewünschte Taste ziehen <br> <img src="img/help/dragkeys.png"/> <br> <b> Wichtig:</b> Deaktivieren Sie diesen Modus wieder, bevor Sie das Inlay weiter bearbeiten oder speichern!',
      changeToSmallerKeys:
        "Möchten Sie zum Layout mit kleineren Tasten wechseln, um Platz für den Bargraph zu erhalten?",
      // chromeMessagePrinting:
      //   "ACHTUNG! Google Chrome druckt die Inlays mit falschen Maßen! Eine Lösung ist bisher leider noch nicht absehbar. Nutzen Sie zum Drucken daher bitte den Firefox ab Version 26.",
      // chooseInlay: "Bitte Inlay auswählen!",
      // chooseTextColor: "Textfarbe wählen",
      climate: "Klima",
      connection: "Anschluss",
      continuous: "durchgängig",
      color: "Farbe",
      // colorgradient: "Farbverlauf",
      // colorHint: "Farbton über Skala wählbar",
      // colorIcons: "Farbicons",
      // colorMode: "Farbtonmodus",
      colorSamples: "Farbvorlagen",
      colorRemove: "Farbe entfernen",
      // colorPicker: "Der Farbwähler",
      // copy: "kopieren",
      // delete: "Löschen",
      // deleteConfirm:
      //   "ACHTUNG! Sollen wirklich alle ausgewählten Inlays gelöscht werden?",
      // designSamples: "Design-Vorlagen und Icons zum Download",
      // download: "Download",
      // downlIcons: "Zusatz-Icons zum Download",
      // draggableText: "Text durch Klick verschiebbar",
      // draggableHelpboxes: "Alle Hilfeboxen sind VERSCHIEBBAR!",
      edit: "bearbeiten",
      fadeIn: "einblenden",
      fadeOut: "ausblenden",
      // fixedText: "Text durch Klick fixiert",
      // fontFamily: "Schriftart",
      // fontSize: "Schriftgröße",
      formatting: "Formatierung",
      // GTSelection: "Auswahl des GTs",
      // help: "Hilfe",
      // home: "Startseite",
      img: "Bild",
      imgEdit: "Bild bearbeiten",
      // imgLoading: "Bild wird geladen",
      // imgsLoading: "Bilder werden geladen",
      imgScale: "Bildskalierung",
      // imgTooLarge:
      //   "ACHTUNG! \n Das gewählte Bild ist sehr groß ( %s x %s px) und führt gegebenenfalls zu schlechteren Druckergebnissen und Verlangsamung des Programms. \n Empfohlene Auflösung für formatfüllende Bilder: \n GT6+GT8: 709x709px \n GT12 697x1571px \n GT10D: 709x709px \n MT4: 614x614px.",
      // imgTooSmall:
      //   "ACHTUNG! Die Größe des gewählten Bildes (%s x %s px) ist nicht geeignet für eine formatfüllende Darstellung. \n Empfohlene Auflösung für formatfüllende Bilder: \n GT6+GT8: 709x709px \n GT12 697x1571px \n GT10D: 709x709px \n MT4: 614x614px.",
      // imgPos: "Bildposition",
      // imgRotation: "Bilddrehung",
      import: "importieren",
      importProject: "Projekt importieren",
      imgRemove: "Bild entfernen",
      inlayName: "Inlayname:",
      // italic: "kursiv",
      // keyCaption: "Tasten beschriftung",
      // keyDesign: "Tasten-Design ",
      // keyHint:
      //   "Taste/n <b>durch Klick aus-</b> und <b>abwählbar</b><br><br>Markierung notwendig für:<ul><li>Farbe</li><li>Bild</li><li>Bildskalierung</li><li>Bildpositionierung</li><li>Ecken</li><li>Rahmen</li><li>Beschriftung -> Ausrichtung</li></ul>",
      // keyImgs: "Tasten-Bilder",
      keyLEDs: "Tasten-LEDs",
      keys: "Tasten",
      // language: "Sprache:",
      // largerKeys: "größere Tasten",
      // layoutChoice: "Auswahl der Tastenanordnung",
      // lcnwebsite: "LCN-Webseite",
      // LEDinfo: "Einzelne LEDs sind durch Doppelklick ausblendbar",
      // LEDPosCenter: "LED-Position mittig",
      // LEDPosKeyBorder: "LED-Position: am Tastenrand",
      LEDs: "LEDs",
      light: "Licht",
      media: "Medien",
      // messageBeforeRefresh: "Wollen Sie wirklich schließen/neu laden?",
      // moveColourpicker: "mit gedrückter Maustaste Farbwähler verschieben",
      moveImg: "Schrittweise verschieben",
      newProj: "Neues Projekt",
      no: "Nein",
      noBorder: "Keine Rahmen",
      // noInlaysInProj: "Es befinden sich keine Inlays in Ihrem Projekt",
      // noImg: "Kein Bild",
      // oldIcons: "Alte Icons vor April 2018",
      // openProj: "Projekt öffnen ",
      outlines: "Ecken",
      // ownBgImgs:
      //   "<b>Eigene Hintergrundbilder</b> mit der Maus von lokalem Rechner auf den GT-Rahmen ziehen <br><b>benötigte Auflösung für Druck mit 300dpi:</b><br>",
      // ownImgs:
      //   "<b>Eigene Bilder</b> mit der Maus von lokalem Rechner auf gewünschte Taste ziehen <br> <b>benötigte Auflösung für Druck mit 300dpi:</b><br>300x270px",
      position: "Bildposition",
      // projLoading: "Projekt wird geladen",
      // pageLoading: "Seite wird geladen...",
      print: "Drucken",
      // printSetting: "Druckeinstellung für Internet Explorer und Firefox:",
      // printSettingIE:
      //   "Extras -> Drucken -> Seite einrichten ->  Hintergrundfarben und -bilder drucken",
      // printSettingInfo:
      //   "Außerdem druckt der Browser standardmäßig Informationen in die Randbereiche. Wählen Sie bei <b>Kopf- und Fußzeile</b> überall <b>„leer“</b>, um nur das Inlay zu drucken.",
      // printSettingFF:
      //   "Datei -> Seite einrichten ->  Hintergrund drucken(Farben und Bilder)",
      // printVisible: "Inlay drucken",
      // proj: "Projekt:",
      // projectNamePlaceholder: "Beispielname",
      // questSmallerKeys:
      //   "Benötigen Sie für Ihr bereits angefertigtes Layout kleinere Tasten, um den Bargraph besser anzuzeigen? Dann schicken Sie uns Ihr Projekt per Mail an hotline@lcn.de",
      removeImg: "Bild entfernen",
      // readPrintInfo:
      //   "BEACHTEN SIE für Internet Explorer und Firefox unbedingt die WICHTIGEN DRUCKEINSTELLUNGEN! \n (Siehe rotes Infoicon oder Kapitel 3.7.3 der Hilfe) ",
      round: "rund",
      // roundedCorner: "abgerundete Ecken",
      // saturationHint: "Sättigung der gewählten Farbe über Skala wählbar",
      // saturationMode: "Sättigungsmodus",
      save: "Alle Inlays Speichern",
      // saveDialogLoading: "Speicherdialog wird geladen",
      selectAll: "Alle auswählen",
      selectGT: "GT bearbeiten und zu Projekt hinzufügen",
      separate: "einzeln",
      // ser2009: "Serie 2009",
      // ser2014: "GT-Serien ab 2014",
      // ser2009Col: "Serie 2009:",
      // ser2014Col: "Serie 2014:",
      // smallKeys: "kleine Tasten",
      // swipingHelp1: "über Navigation",
      // swipingHelp2:
      //   "oder mit geklickter linker Maustaste <b>auf dem Rahmen des GTs nach links oder rechts wischen</b> ",
      // swipingHelp3:
      //   "oder mit geklickter linker Maustaste <b>auf dem Inlay nach oben oder unten wischen</b>",
      firstColor: "Erste Farbe",
      secondColor: "Zweite Farbe",
      "central-control": "Zeit-/ Zentral- steuerung",
      "color-gradient": "Farbverläufe",
      toProjOverview: "zur Projektübersicht",
      // toGT09: "zu GT-Serie 2009 ->",
      // toGT14: "zu GT-Serie ab 2014 ->",
      // toolbarPosHint:
      //   "<b>Doppelklick</b> auf Hintergrund setzt <b>Toolboxen</b> auf <b>Standardposition</b> zurück",
      undo: "Rückgängig",
      // underline: "unterstrichen",
      // valignBottom: "unten ausrichten",
      // valignMiddle: "mittig ausrichten(vertikal)",
      // valignTop: "oben ausrichten",
      welcome: "Herzlich Willkommen!",
      // welcomeText1:
      //   'Sie befinden sich in einem <b>neuen leeren Projekt.</b> <br> Um diesem Projekt ein GT-Inlay hinzu- <br> zufügen, klicken Sie auf die <b>Schaltfläche <br>"Inlay hinzufügen"</b><br><br> Ein Projekt ist ein Zip-Ordner, in dem alle dazugehörigen Inlays abgespeichert werden.<br>Geben Sie ihm den Namen <br>des entsprechenden Bauvorhabens. ',
      // welcomeText2:
      //   "Alternativ können Sie ein <br><b>bestehendes Projekt öffnen.</b>",
      // whiteBargrLEDs: "weiße Bargraph-LEDs",
      window: "Fenster",
      yes: "Ja",
    },
  },
  en: {
    message: {
      central: "Time-/ Central Control",
      windows: "Window",
      others: "Others",
      security: "Access/ Security",
      other: "Others",
      deactivate: "Deactivate",
      activate: "Activate",
      content: "Content",
      inlays: "Project inlays",
      selectGTs: "Select GTs",
      barGrLEDs: "Bargraph-LEDs",
      noSelection: "No selection",
      icons: "Icons",
      chooseProjectName: "Please enter a new project name",
      next: "Continue",
      oldModels: "Show GT Models from Series 2009",
      newModels: "Show GT Models from Series 2013",
      oldGTD:
        'This is the new GT-Designer! <br> Projects created with the old designer cannot be imported into the new one. If you would like to access the old GT-Designer you can do so <a href="https://lcn.eu/gtdesignerlegacy">here</a>.</small>',

      saveSelected: "Save selection",
      deleteSelected: "Delete selection",
      buttonSelection: "Button selection",
      changeOrientationVertical: "Vertical Orientation",
      changeOrientationHorizontal: "Horizontal Orientation",
      changeOrientation: "Switch Orientation",
      hideSelectedLEDs: "hide selection",
      additionalText: "Additional Caption",
      move: "move",
      hotel: "Hotel",
      clickGT: "Please click a GT Model",
      deselectAll: "Deselect all",
      revertKeys: "Would you like to return to the original key layout?",

      // access: "Access/<br>Security",
      add: "Add",
      projectname: "Projectname",
      // addAndEdit: "add and edit",
      // addInlay: "Add inlay",
      // addText: "Add text",
      // aidinglines: "Aiding lines",
      // alphaHint:
      //   "Transparency of chosen colour	selectable <br> with vertical transparency bar",
      // alphaMode: "Transparency mode",
      alignment: "Alignment",
      // alignmentInfo: "select key and click appropriate icon for text-alignment",
      // alignCenter: "align center(horizontal)",
      // alignLeft: "align left",
      // alignRight: "align right",
      // allTexts: "Mark all texts",
      // allTextsInfo: "Works only in Firefox",
      angle: "Angle",
      angled: "Angled",
      // apply: "apply",

      // back: "Back",
      background: "Background",
      // backgroundImgs: "Background images",
      backToProjOverview: "Back to project overview",
      // bargrCaption: "Bargraph- caption",
      // "Black-and-white-icons": "Black-and-white-icons",
      border: "Border colours",
      // bold: "bold",
      // brightnessHint:
      //   "Brightness of chosen colour selectable <br> with vertical brightness bar",
      // brightnessMode: "Brightness mode",

      caption: "Caption",
      // captionHint1: "Click with cursor into text to edit with keyboard ",
      // captionHint2: "Delete with backspace ← or delete key",
      changeMode: "Key swapping",
      // changeModeInfo:
      //   'Activate the swap icon and you can <b>swap keys</b>.<br> Drag key with cursor to desired key <br> <img src="img/help/dragkeys.png"/> <br> <b> Important:</b> Deactivate this mode, before editing and saving inlays!',
      changeToSmallerKeys:
        "Do you want to change to layout with smaller keys to have space for the bargraph?",
      // chromeMessagePrinting:
      //   "ATTENTION! Google Chrome prints the inlays with wrong measurement! A solution is not foreseeable. Please use Firefox Version 26 or higher.",
      // chooseInlay: "Please choose inlay!",
      // chooseTextColor: "Choose the color of text",
      climate: "Climate",
      connection: "Connection",
      continuous: "continuous",
      color: "Colour",
      // colorHint: "Colour mode selectable with vertical colour bar <br> &nbsp;",
      // colorIcons: "<br>Colour",
      // colorMode: "Colour mode",
      colorSamples: "Colour samples",
      colorRemove: "Remove color",
      // colorPicker: "Colour picker",
      // copy: "copy",

      // delete: "delete",
      // deleteConfirm: "ATTENTION! You delete all chosen inlays.",
      // designSamples: "Design samples and icons for download",
      // download: "Download",
      // draggableText: "Text draggable by clicking icon",
      // draggableHelpboxes: "All helpboxes are DRAGGABLE!",

      edit: "edit",

      fadeIn: "show",
      fadeOut: "hide",
      // fixedText: "Text fixed by clicking icon",
      // fontFamily: "Schriftart",
      // fontSize: "font size",
      formatting: "Formatting",

      // GTSelection: "GT selection",

      // help: "Help",
      // home: "Home",

      // IE5Hint:
      //   "You use Internet Explorer 5! The GT-Designer is usable from version 9.",
      // IE6Hint:
      //   "You use Internet Explorer 6! The GT-Designer is usable from version 9.",
      // IE7Hint:
      //   "You use Internet Explorer 7! The GT-Designer is usable from version 9.",
      // IE8Hint:
      //   "You use Internet Explorer 8! The GT-Designer is usable from version 9.",
      // IE9InfoBox:
      //   '<hr>You use <b>Internet Explorer 9</b><br><br>GT-Designer is usable with three restrictions here:<br><ul><li>No possibility for using own images (drag and drop from your local computer works with Internet Explorer 10 or higher)</li><li>Key swapping: Not possible to swap keys</li><li>horizontal positioning of key texts doesn`t work correctly<br><b>Alternative solution:</b> Add texts (in toolbox "Caption")  -> add and move to desired place</li></ul><br>Whole functionality is given in Firefox version 26 or higher.',
      // IE10InfoBox:
      //   '<hr>You use <b>Internet Explorer 10</b><br><br>GT-Designer is usable with two restrictions here:<br><ul><li>Key swapping: Not possible to swap keys</li><li>horizontal positioning of key texts doesn`t work correctly<br><b>Alternative solution:</b> Add texts (in toolbox "Caption")  -> add and move to desired place</li></ul><br>Whole functionality is given in Firefox from version 26.',
      // IE11InfoBox:
      //   '<hr>You use <b>Internet Explorer 11</b><br><br>GT-Designer is usable with two restrictions here:<br><ul><li>Key swapping: Not possible to swap keys</li><li>horizontal positioning of key texts doesn`t work correctly<br><b>Alternative solution:</b> Add texts (in toolbox "Caption")  -> add and move to desired place</li></ul><br>Whole functionality is given in Firefox from version 26.',
      img: "Image",
      imgEdit: "Edit image",
      // imgLoading: "Image is loading",
      // imgsLoading: "Images are loading",
      imgScale: "Image scale",
      // imgTooLarge:
      //   "ATTENTION! \n The chosen image is too large ( %s x %s px) and can cause bad printing results and loss of performance. \n Recommended resolution for format filling images: \n GT6: 709x709px \n GT12 697x1571px \n GT10D: 709x709px \n MT4: 614x614px.",
      // imgTooSmall:
      //   "ATTENTION! The size of chosen image(%s x %s px) is not suitable for a format filling display. \n Recommended resolution for format filling images: \n GT6: 709x709px \n GT12 697x1571px \n GT10D: 709x709px \n MT4: 614x614px.",
      // imgPos: "Image position",
      // imgRotation: "Image rotation",
      import: " import",
      importProject: "Import Project",
      removeImg: "Remove image",
      inlayName: "Inlay name:",
      // important: "IMPORTANT",
      // importantInfo: "Important info",
      // importTitle: "import another project into the opened project",
      // infoTextLayoutGT6_1:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 (2013) 1,2+2</b> <br> <a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT6_2:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 (2013) 1+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT6_3:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 (2013) 2+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT6_4:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 (2013) 1,3</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT6_5:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 (2013) 3,1</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',

      // infoTextLayoutGT8_1:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT8</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT8_2:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT8 1,4+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT8_3:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT8 2,2+4</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',

      // infoTextLayoutGT12_1:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 1,8+6</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_2:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 2,4+4</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_3:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 3+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_4:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 8,1+6</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_5:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 8,1+6</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_6:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 6+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_7:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 6+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_8:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 2,1+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_9:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 (2013) 2,1+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayoutGT12_10:
      //   "<b>ATTENTION!</b> <br>You can programm this layout only since <br> <b>LCN-PRO 6</b>! <br> Choose layout: <br><b>LCN-GT12 (2013) 1,8,1+6</b>",

      // infoTextLayout09GT6_1:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 1,2+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT6_2:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 1+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT6_3:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT6 2+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',

      // infoTextLayout09GT12_1:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 1,8+6</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT12_2:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 2,4+4</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT12_3:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 3+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT12_4:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 8,1+6</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT12_5:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 8,1+6</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // infoTextLayout09GT12_6:
      //   'ONLY usable with correct mapping in LCN-PRO! <br> Layout: <b>LCN-GT12 6+2</b> <br><a class="moreInfo" href="img/LCNPRO.png" target="_blank">More info</a>',
      // inlayName: "Inlayname:",
      // italic: "italic",

      // keyCaption: "Key caption",
      // keyDesign: "Key design ",
      // keyHint:
      //   "Key/s are <b>selectable</b> and <b>deselectable by clicking</b><br><br>It is necessary to select the key/s for editing:<ul><li>Colour</li><li>Image</li><li>Image scale</li><li>Image position</li><li>Outlines</li><li>Border colours</li><li>Caption -> Alignment</li></ul>",
      // keyImgs: "Key images",
      keyLEDs: "Key LEDs",
      keys: "Keys",

      // language: "language:",
      // largerKeys: "larger keys",
      // layoutChoice: "GT-layout selection",
      // lcnwebsite: "LCN-Website",
      // LEDinfo: "Hide single LED`s with doubleclick",
      // LEDPosCenter: "LED`s are positioned centrally",
      // LEDPosKeyBorder: "LED position: border of key",
      // messageBeforeRefresh: "Do you really want to close/refresh the page?",
      LEDs: "LEDs",
      light: "Light",

      media: "Media",
      // moveColourpicker: "move colour picker with pressed mouse button",
      moveImg: "move stepwise",

      newProj: "New project",
      no: "No",
      noBorder: "No border",
      // noInlaysInProj: "There are no inlays in your project",
      // NoImg: "Kein Bild",
      position: "Position",

      // oldIcons: "Old Icons before April 2018",
      // openProj: "Open project&nbsp;",
      outlines: "Outlines",
      // ownBgImgs:
      //   "<b>Own background images</b> Drag with the cursor from your local computer to frame of the GT<br><b>Required resolution for printing with 300dpi: </b><br>",
      // ownImgs:
      //   "<b>Own images</b> Drag with the cursor from your local computer to desired key <br> <b>Required resolution for printing with 300dpi: </b><br>300x270px",
      print: "Print",
      // printSetting: "Print settings for Internet Explorer and Firefox:",
      // printSettingIE:
      //   "Extras -> Print -> Page Setup -> Print Background(colours & images)",
      // printSettingInfo:
      //   'Furthermore the browser prints information by default into the border area. Choose „--blank--“ for "Header&Footer" at tab "Margins & Header/Footer" , for printing the inlay only.',
      // printSettingFF:
      //   "Print -> Page Setup ->  Print Background(colours & images)",
      // printVisible: "Print inlay",
      // proj: "Project:",
      // projectNamePlaceholder: "Add name of project",

      // questSmallerKeys:
      //   "If you need smaller keys, send your inlay to hotline@lcn.de",

      // readPrintInfo:
      //   "Please be aware of the IMPORTANT PRINTER SETTINGS when using Internet Explorer and Firefox! \n (see red info icon or chapter 3.7.3 in the help file) ",
      round: "round",
      // roundedCorner: "rounded corner",

      // saturationHint:
      //   "Saturation of chosen colour selectable <br> with vertical saturation bar",
      // saturationMode: "Saturation mode",
      save: "Save entire project",
      // saveDialogLoading: "Save dialog is loading",
      selectAll: "Select all",
      selectGT: "Select GT and add to project",
      separate: "separate",
      // ser2009: "Series 2009",
      // ser2014: "Series 2014",
      // ser2009Col: "Series 2009:",
      // ser2014Col: "Series 2014:",
      // smallKeys: "small keys",
      // swipingHelp1: "with navigation",
      // swipingHelp2:
      //   "or with left mouse button pressed while <b>swiping on frame of GT towards the left or right</b> ",
      // swipingHelp3:
      //   "or with left mouse button pressed while <b>swiping on inlay towards the top or bottom</b>",
      firstColor: "First color",
      secondColor: "Second color",
      "color-gradient": "Color gradient",
      "central-control": "Time / central control",
      toProjOverview: "to project overview",
      // toolbarPosHint:
      //   "<b>Doubleclick</b> on background sets <b>toolbars</b> to <b>default position</b>",

      undo: "Undo",
      // underline: "underline",

      // valignBottom: "vertikal-align bottom",
      // valignMiddle: "vertikal-align middle",
      // valignTop: "vertikal-align top",

      welcome: "Welcome!",
      // welcomeText1:
      //   'You are in a <b>new empty project</b>.<br> To add a GT inlay to this project<br> click the <b>button "Add inlay"</b><br><br>A project is a zip folder, in which <br>all appendant inlays are saved. <br> Name it according to the <br>"building project". ',
      // welcomeText2:
      //   "Alternatively you can<br> <b>open an existing project.</b> ",
      // whiteBargrLEDs: "white bargraph LED`s",
      window: "Window",

      yes: "Yes",
    },
  },
};
